import { SvgIcon } from '@mui/material';

const ChevronIcon = () => (
  <SvgIcon
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 4.5L10 8.5L6 12.5"
      stroke="#18A0FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default ChevronIcon;
